import { mapState } from '../../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import DiffsFileTree from '../../../diffs/components/diffs_file_tree.vue?vue3';
import { useDiffsList } from '../../stores/diffs_list.js?vue3';
import { useFileBrowser } from '../../../diffs/stores/file_browser.js?vue3';
import { useDiffsView } from '../../stores/diffs_view.js?vue3';
export default {
    name: 'FileBrowser',
    components: {
        DiffsFileTree
    },
    props: {
        groupBlobsListItems: {
            type: Boolean,
            required: false,
            default: true
        },
        linkedFilePath: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'click-file'
    ],
    data () {
        return {
            currentFileHash: ''
        };
    },
    computed: {
        ...mapState(useDiffsView, [
            'totalFilesCount',
            'singleFileMode',
            'currentFileIndex'
        ]),
        ...mapState(useDiffsList, [
            'loadedFiles'
        ]),
        ...mapState(useFileBrowser, [
            'fileBrowserVisible',
            'flatBlobsList'
        ]),
        treeLoadedFiles () {
            return this.singleFileMode ? null : this.loadedFiles;
        },
        currentDiffFileId () {
            let hash = this.currentFileHash;
            if (this.singleFileMode) {
                hash = this.flatBlobsList[this.currentFileIndex]?.fileHash ?? '';
            }
            return hash;
        }
    },
    methods: {
        clickFile (file) {
            this.currentFileHash = file.fileHash;
            this.$emit('click-file', file);
        },
        toggleFolder (path) {
            useFileBrowser().toggleTreeOpen(path);
        }
    }
};
